import React from 'react';
//import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import './sass/styles.scss';

import App from './App';
//import * as serviceWorker from './worker';
import reportWebVitals from './reportWebVitals';

//serviceWorker.register();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<BrowserRouter> <App /></BrowserRouter>);

/*
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
